import { MapPin, Mail, Phone, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-50 flex flex-col justify-center items-center w-full py-4 lg:py-8">
      <section className="flex flex-col lg:flex-row justify-center lg:justify-between py-3 lg:py-4 px-4 lg:px-16 xl:px-40 w-full gap-6 lg:gap-12">
        <address className="flex flex-col text-xl not-italic">
          <h3 className="text-center lg:text-left font-bold text-xl pb-3">Contato</h3>
          <div className="flex flex-col gap-3 items-center lg:items-start">
            <div className="flex flex-row items-center gap-2 text-sm lg:text-base text-center lg:text-left">
              <MapPin className="h-5 w-5 flex-shrink-0 text-yellow-300" />
              <div className="flex flex-col">
                <span>Rua Manoel Sylvestre de Freitas Filho, 1224</span>
                <span>Bloco 3, Apto 202 - Campinas</span>
                <span>CEP: 13040-089</span>
              </div>
            </div>
            <a 
              href="mailto:contato@ahqconsultoriaemengenharia.com.br?subject=Contato%20do%20Site&body=Olá,%20tudo%20bem?%0D%0A%0D%0AEstou%20interessado%20em..." 
              className="flex flex-row gap-2 items-center hover:text-yellow-300 transition-colors"
            >
              <Mail className="h-5 w-5 flex-shrink-0 text-yellow-300" />
              <span className="text-sm lg:text-base break-all">contato@ahqconsultoriaemengenharia.com.br</span>
            </a>
            <a 
              href="https://api.whatsapp.com/send?phone=5511986162105&text=Olá,%20" 
              className="flex flex-row gap-2 items-center hover:text-yellow-300 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle className="h-5 w-5 flex-shrink-0 text-yellow-300" />
              <span className="text-sm lg:text-base">(11) 98616-2105</span>
            </a>
            <a 
              href="tel:12988267109" 
              className="flex flex-row gap-2 items-center hover:text-yellow-300 transition-colors"
            >
              <Phone className="h-5 w-5 flex-shrink-0 text-yellow-300" />
              <span className="text-sm lg:text-base">(12) 98826-7109</span>
            </a>
          </div>
        </address>
        
        <div className="w-full lg:w-auto lg:min-w-[300px] h-48 lg:h-64">
          <iframe
            title="Google Maps - AHQ Consultoria"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade" 
            src="https://www.google.com/maps?q=Rua%20Manoel%20Sylvestre%20de%20Freitas%20Filho,%201224,%20Campinas,%20SP&output=embed"
            className="rounded-lg"
          />
        </div>
      </section>
      
      <span className="text-sm text-center lg:text-base py-4 px-4 border-t border-gray-700 w-full">
        &copy; 2025 <strong>AHQ Consultoria em Engenharia</strong>. Todos os direitos reservados.
      </span>
    </footer>
  );
};
